import { Outlet } from 'react-router-dom'

import { useAdminLeadNotifications } from '@/modules/admin/hooks/useAdminLeadNotifications'
import { useMessageNotifications } from '@/modules/messages/hooks/useMessageNotifications'
import { useCommentNotifications } from '@/modules/sales/hooks/useCommentNotifications'
import { useSalesLeadNotifications } from '@/modules/sales/hooks/useSalesLeadNotifications'
import { AppNavbar } from '@/shared/components/layout/AppNavbar'

export function DashboardLayout() {
  useCommentNotifications()
  useAdminLeadNotifications()
  useSalesLeadNotifications()
  useMessageNotifications()

  return (
    <div className="min-h-dvh overflow-x-hidden bg-surface-page">
      <AppNavbar />

      <main className="mx-auto min-h-[calc(100dvh-7.5rem)] w-full max-w-[1400px] px-3 py-3 pb-8 sm:px-4 sm:py-4 md:px-6">
        <Outlet />
      </main>
    </div>
  )
}
